import instance from '../axios';

/**
 * 다운로드
 */
export const downloadFile = async (attachment: {
  url: string;
  sid?: number;
  fileNm: string;
  filePath?: string;
  isZipFile: boolean;
}) => {
  try {
    const url = attachment.isZipFile
      ? `${attachment.url}/download/zip`
      : `${attachment.url}/download?filePath=${attachment.filePath}`;

    const response = await instance.get(url, {
      headers: { 'Content-Type': 'application/octet-stream' },
      responseType: 'blob',
    });

    if (response.data) {
      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/octet-stream',
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      // 가상 링크 생성 + 클릭
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', attachment.fileNm || 'downloaded_file');
      document.body.appendChild(link);
      link.click();

      // URL 해제 및 링크 제거
      setTimeout(() => {
        window.URL.revokeObjectURL(downloadUrl);
        link.remove();
      }, 100);
    }
  } catch (error) {
    console.error('파일 다운로드 실패:', error);
  }
};

/**
 * zip 파일 다운로드
 */
export const downloadZipFile = async (downloadUrl: string, fileNm: string) => {
  try {
    const url = `${downloadUrl}/download/zip`;

    // 1. HTTP 요청 헤더와 응답 타입 설정
    const response = await instance.get(url, {
      // 서버에 zip 형식의 응답을 요청
      headers: { Accept: 'application/zip' },
      // 응답은 blob 형태로 받도록
      responseType: 'blob',
    });

    if (!response.data) {
      throw new Error('No data received');
    }

    // 2. Blob 객체 생성
    if (response.data) {
      const blob = new Blob([response.data], {
        // response.headers['content-type']이 없으면 'application/zip' 사용
        type: response.headers['content-type'] || 'application/zip',
      });

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      // 가상 링크 생성 + 클릭
      link.href = downloadUrl;
      link.download = `${fileNm}.zip`;

      // Dom에 추가하지 않고 직접 클릭 이벤트 발생
      document.body.appendChild(link);
      link.click();

      // URL 해제 및 링크 제거
      setTimeout(() => {
        window.URL.revokeObjectURL(downloadUrl);
        link.remove();
      }, 100);
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 회사 소개서 다운로드
 */

export const downloadCompanyIntro = async (attachment: { fileNm: string; langCd: string }) => {
  try {
    const url = `/v1/companyInfo/companyIntro?langCd=${attachment.langCd}`;

    const response = await instance.get(url, {
      headers: { 'Content-Type': 'application/octet-stream' },
      responseType: 'blob',
    });

    if (response.data) {
      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/octet-stream',
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      // 가상 링크 생성 + 클릭
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', attachment.fileNm || 'downloaded_file');
      document.body.appendChild(link);
      link.click();

      // URL 해제 및 링크 제거
      setTimeout(() => {
        window.URL.revokeObjectURL(downloadUrl);
        link.remove();
      }, 100);
    }
  } catch (error) {
    console.error('파일 다운로드 실패:', error);
  }
};
